module.exports = __webpack_public_path__ + "static/media/05-05.94473d19.png";